
const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';
export {
  GET_DATA_SUCCESS,
};
